export default __webpack_public_path__ + "static/media/image-content-2.deb20416.jpg";